(ns shared.core.components.input-range
  (:require [shared.core.style :as style]
            [shared.core.util :as util]
            [shared.core.reactive :as re]
            [shared.core.components.theme :as theme]))

(def track-styles {:animate "0.2s"
                   :background "transparent"
                   :cursor :pointer
                   :height "6px"
                   :width "100%"})
(def thumb-styles {:background (style/color :green :base)
                   :border (str "1px solid " (style/color :green :base))
                   :border-radius "50%"
                   :cursor :pointer
                   :height "16px"
                   :width "16px"})
(def theme-thumb-styles {:dark {:background (style/dark-color :primary :base)
                                :border (str "1px solid " (style/dark-color :primary :base))}})

(def primary-thumb-styles {:background (style/color :primary :base)
                           :border (str "1px solid " (style/color :primary :base))})

(style/add-css ["input[type=range]:focus" {:outline :none}]
               ["input[type=range]::-webkit-slider-runnable-track" (merge track-styles
                                                                          {:border :none})]
               ["input[type=range]::-webkit-slider-thumb" (merge thumb-styles
                                                                 {:margin-top "-5px"
                                                                  :-webkit-appearance :none})]
               ["input[type=range].dark::-webkit-slider-thumb" (get theme-thumb-styles :dark)]
               ["input[type=range]::-moz-range-track" (merge track-styles
                                                             {:border :none})]
               ["input[type=range]::-moz-range-thumb" thumb-styles]
               ["input[type=range].dark::-moz-range-thumb" (get theme-thumb-styles :dark)]

               [".primary input[type=range]::-webkit-slider-thumb" primary-thumb-styles]
               [".primary input[type=range]::-moz-range-thumb" primary-thumb-styles])

(defn input-range [_]
  (let [theme- (re/subscribe [:core/theme-])]
    (fn [{:keys [class-name value min max style left-bar-style right-bar-style] :as args}]
      [:div {:class-name class-name
             :style (merge {:position :relative
                            :width "100%"}
                           style)}
       [:input (merge {:type :range
                       :value value
                       :class (when @theme- @theme-)
                       :style (merge {:background :transparent
                                      :margin 0
                                      :position :absolute
                                      :top 0
                                      :left 0
                                      :transform "translateY(-50%)"
                                      :width "100%"
                                      :z-index (style/z :medium)
                                      :-webkit-appearance :none}
                                     style)}
                      (dissoc args :style :left-bar-style :right-bar-style))]
       [:div {:style {:display :flex
                      :position :absolute
                      :top "50%"
                      :left 0
                      :transform "translateY(-50%)"
                      :width "100%"
                      :z-index (style/z :low)}}
        [theme/theme
         :div {:style (merge {:background (style/color :green :base)
                              :flex (str "0 0 " (str (* (/ (- value min) (- max min)) 100) "%"))
                              :height 6}
                             left-bar-style)
               :theme (style/dark-style {:background (style/dark-color :primary :base)})}]
        [:div {:style (merge {:background (style/color :white :base)
                              :flex 1
                              :height 6}
                             right-bar-style)}]]])))

(defn primary-input-range [{:keys [left-bar-style right-bar-style] :as args}]
  [input-range (assoc args :class-name (str "primary " (or (:class-name args) ""))
                           :left-bar-style (merge {:background (style/color :primary :base)
                                                   :border-radius "3px 0 0 3px"}
                                                  left-bar-style)
                           :right-bar-style (merge {:border-radius "0 3px 3px 0"}
                                                   right-bar-style))])
